import { EavAttributeValueTypeEnum } from '@zaoblako/shared/modules/eav/enums/eav-attribute-value-type.enum';
import { EavAttributeValueTypeEnumI18n } from '@zaoblako/shared/modules/eav/i18n/eav-attribute-value-type-enum.i18n';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { EavDtoKeysEnum } from '@zaoblako/shared/modules/eav/enums/eav-dto-keys.enum';
import { idLikeSchema } from '@zaoblako/shared/modules/serde/schemas/id-like.schema';
import { nonEmptyStringSchema } from '@zaoblako/shared/modules/serde/schemas/non-empty-string.schema';
import { commonEnumValidator } from '@zaoblako/shared/modules/serde/validators/common-enum.validator';
import { entityLikeSchema } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import type { HelpdeskTaskStatusFindInterface } from '@zaoblako/shared/modules/helpdesk/dto/helpdesk-task-status-find.dto';

import * as yup from 'yup';

/** EAV attribute created and update APIs request body - DTO signature */
export interface EavAttributeFormInterface {
  /** Unique ID. If defined and attribute exists, then it will be updated. */
  id?: number;
  /** EAV attribute display name */
  name: string;
  /** EAV attribute value type */
  type: EavAttributeValueTypeEnum;
  /**
   * If `true` then several value will be array of selected objects.
   * Using only when {@link EavAttributeEntity.type} equals:
   *   - {@link EavAttributeValueTypeEnum.FILIAL} (multiple filials selection);
   *   - {@link EavAttributeValueTypeEnum.COST_CENTER} (multiple cost centers selection);
   */
  multipleSelect?: boolean;
  /**
   * HelpDesk task statuses where this attribute's value is required.
   * Using only for EAV entities related to HD tasks.
   */
  requiredOnHdTaskStatuses?: HelpdeskTaskStatusFindInterface[];
}

/** EAV attribute created and update APIs request body - DTO schema */
export const EavAttributeFormDto = SerdeDtoClass.create<EavAttributeFormInterface>(EavDtoKeysEnum.EAV_ATTRIBUTE_FORM_DTO, {
  id: {
    optional: true,
    label: 'Номер',
    serializer: idLikeSchema,
  },
  name: {
    label: 'Название',
    serializer: nonEmptyStringSchema,
  },
  type: {
    label: 'Тип',
    serializer: commonEnumValidator(EavAttributeValueTypeEnum, EavAttributeValueTypeEnumI18n),
  },
  multipleSelect: {
    optional: true,
    label: 'Множественный выбор',
    serializer: yup.boolean(),
  },
  requiredOnHdTaskStatuses: {
    optional: true,
    label: 'Обязателен для заявок HD со статусами',
    serializer: yup.array(entityLikeSchema),
  },
});
